import { Member } from 'core/api/client/MemberApi';

/**
 * Checks if user has multiple accounts
 *
 * @param member - current member object from MemberContext
 */
export const isMultipleAccounts = (member?: Member): boolean => {
	if (!member || !member.accounts) {
		return false;
	}

	//TODO [NJU] No need to add fallback since boolean expresions are never null or undefined
	return member.accounts.length > 1;
};
